import { render, staticRenderFns } from "./EventsPreview.vue?vue&type=template&id=af1e810a&scoped=true"
import script from "./EventsPreview.vue?vue&type=script&lang=js"
export * from "./EventsPreview.vue?vue&type=script&lang=js"
import style0 from "./EventsPreview.vue?vue&type=style&index=0&id=af1e810a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1e810a",
  null
  
)

export default component.exports